// extracted by mini-css-extract-plugin
export var dividerLine = "_8t-3";
export var itemImage = "_8t-9";
export var lightDivider = "_8t-4";
export var modalContent = "_8t-5";
export var modalContentCompact = "_8t-6";
export var productCard = "_8t-a";
export var productImage = "_8t-b";
export var productImageCompact = "_8t-7";
export var productImagePlaceholder = "_8t-c";
export var productImagePlaceholderCompact = "_8t-8";
export var progressBarBackground = "_8t-1";
export var progressBarContainer = "_8t-0";
export var progressBarFill = "_8t-2";